module.exports = __webpack_public_path__ + "img/add_new_books_hover.28463fc5.png";